import { render } from "./LoginComponent.vue?vue&type=template&id=408a8216&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=408a8216&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408a8216"]])

export default __exports__